function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.slider-nav-restore-1,.slider-nav-restore-2{fill:none;stroke:#75a2cf;stroke-miterlimit:10;}.slider-nav-restore-1{fill-rule:evenodd;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "slider-nav-restore-1",
  d: "M305.18,430.5c-2.37,0-14.85,0-14.85,0h0c-.21,0-.49,0-.71,0a5.55,5.55,0,1,1,0-11.09h.15c0-.16-.05-.32-.05-.48,0-3.83,3.44-6.94,7.69-6.94s7.69,3.11,7.69,6.94c0,.17,0,.32-.05.48h.15a5.55,5.55,0,1,1,0,11.09Z",
  transform: "translate(-283.3 -411.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "slider-nav-restore-2",
  points: "16.1 13 16.1 7 12.1 7 12.1 13 9.1 13 14.1 18 19.1 13 16.1 13"
});

var SvgRestore = function SvgRestore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.2 19.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restore.624ac180.svg";
export { ForwardRef as ReactComponent };